import { MaybeRefOrGetter } from "vue";
import { Arrayable, useEventListener } from "@vueuse/core";

/**
 * Used to attach a keyboard event listener to a target window.
 * This is useful for handling keyboard events such as arrow keys.
 * @param target - Window to attach the event listener to
 * @param onNext - Function to call when the right arrow key is pressed
 * @param onPrevious - Function to call when the left arrow key is pressed
 */
export function useKeyboardEvent(
  targets: MaybeRefOrGetter<Arrayable<EventTarget>>,
  {
    onNext,
    onPrevious,
  }: {
    onNext: () => void | Promise<void>;
    onPrevious: () => void | Promise<void>;
  }
) {
  const handleKeyup = async (event: KeyboardEvent) => {
    if (event.key === "ArrowRight") await onNext();
    if (event.key === "ArrowLeft") await onPrevious();
  };

  useEventListener(targets, "keyup", handleKeyup, { passive: true });
}
